import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const GenerateTabContainer = styled.div`
  padding-top: 24px;
  padding-inline: 14px;
  margin-right: 28px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: calc(100% + 28px);

  overflow: hidden overlay;
  ${customizeVerticalScrollbarThumbMixin()}
`
